import {
  ACTION_LOGOUT,
  FETCH_LOGIN_FAILURE,
  FETCH_LOGIN_SUCCESS,
  FETCH_USER_INFO_FAILURE,
  FETCH_USER_INFO_REQUEST,
  FETCH_USER_INFO_SUCCESS,
  SET_USER_PROFILE,
} from "./actions.type";
import {
  ActionLogout,
  FetchLoginFailure,
  FetchLoginSuccess,
  FetchUserProfileFailure,
  FetchUserProfileRequest,
  FetchUserProfileSuccess,
  SetUserProfile,
} from "./types";

export const fetchLoginSuccess = (): FetchLoginSuccess => ({
  type: FETCH_LOGIN_SUCCESS,
});

export const fetchLoginFailure = (): FetchLoginFailure => ({
  type: FETCH_LOGIN_FAILURE,
});

export const fetchUserProfileRequest = (payload: string): FetchUserProfileRequest => ({
  type: FETCH_USER_INFO_REQUEST,
  payload,
});

export const fetchUserProfileSuccess = (payload?: Keycloak.KeycloakProfile): FetchUserProfileSuccess => ({
  type: FETCH_USER_INFO_SUCCESS,
  payload,
});

export const fetchUserProfileFailure = (): FetchUserProfileFailure => ({
  type: FETCH_USER_INFO_FAILURE,
});

export const setUserProfile = (payload?: Keycloak.KeycloakProfile): SetUserProfile => ({
  type: SET_USER_PROFILE,
  payload,
});


export const actionLogout = (): ActionLogout => ({
  type: ACTION_LOGOUT,
});
